// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
// import BaiduMap from 'vue-baidu-map'
import router from './router'
import Antd, {message} from 'ant-design-vue'
import i18n from '@/plugins/i18n.js'
import store from './store';
import "@/plugins/rem.js";
import "@/plugins/animation.js"
import 'ant-design-vue/dist/antd.css';
import animated from 'animate.css'
import VueClipboard from 'vue-clipboard2'
import onlyNumber from '@/plugins/onlyNumber'; //添加此行=>自定义全局指令
import dataV from '@jiaminghi/data-view'

Vue.config.productionTip = false

Vue.use(Antd); 
Vue.use(dataV)
Vue.use(animated)
Vue.use(VueClipboard)
Vue.use(onlyNumber)
// Vue.use(BaiduMap, {
//   ak: '34jkeGdCtyvlQXO3vDtWjsWWLYGoIN4p'
// })
Vue.prototype.$form = Antd.Form
Vue.prototype.$message = message

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js